import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import "./LiveOrder.css";
import { fetchLiveOrder, fetctCancelledOrder } from "../../redux/action";
import { OrderStatus } from "../../Utills/enums";
import { formatFullDate } from '../../Utills/utils';
import EmptyScreen from "../../component/common/EmptyScreen";

const CancelledOrder = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const realtimeRevision = useSelector(state => state.notifications?.ordersRevision || 0);
  const orderList = useSelector((state) => state.admin.cancelledOrder);

  // ✅ Date range state (default today)
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  useEffect(() => {
    console.log("fetchCancelledorder", orderList);
    dispatch(fetctCancelledOrder());
  }, [dispatch, realtimeRevision]);

  console.log("orderList", orderList);

  // ✅ Filter in UI
  // const filteredOrders = Array.isArray(orderList)
  //   ? orderList.filter(order => {
  //       const orderDate = new Date(order.orders?.[0]?.orderDateTime);
  //       const start = new Date(startDate);
  //       const end = new Date(endDate);
  //       console.log("orderDate",orderDate)
  //       console.log("start",start)
  //       console.log("end",end)
  //       console.log("return",orderDate >= start && orderDate <= end)
  //       return orderDate >= start && orderDate <= end;
  //     })
  //   : [];


  const filteredOrders = Array.isArray(orderList) ? orderList.filter(order => {
    // Convert date string to local midnight
    const toLocalDate = (dateStr) => {
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day); // local midnight
    };
    const start = toLocalDate(startDate);
    const end = toLocalDate(endDate);

    // If you want inclusive end date, add 1 day
    end.setDate(end.getDate() + 1);

    const orderDate = new Date(order.orders?.[0]?.orderDateTime);
    return orderDate >= start && orderDate < end;
  }) : [];


  //   if (!orderList || orderList.length === 0) {
  //     return <p>Loading Cancelled orders...</p>;
  //   }

  return (
    <div>
      <div className="filter-bar">
        <div className="filter-item">
          <label>Start:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="filter-item">
          <label>End:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
      <div className="dotted-line"></div>

      {filteredOrders.length > 0 ?
        <div className="order-list">
          {filteredOrders.map((order, idx) => {
            // ✅ Pick one status (first item’s status)
            const firstStatus = order.orders?.[0]?.status;
            const orderDateTime = order.orders?.[0]?.orderDateTime;

            return (
              <div key={idx} className="order-card">
                <div className="order-header">
                  <span className="order-id">{t("Order")} #{order.orderNumber}</span>
                  <span className="status served">{formatFullDate(orderDateTime)}</span>

                  {firstStatus !== undefined && (
                    <div
                      className={`status ${OrderStatus[firstStatus].toLowerCase()}`}
                    >
                      {OrderStatus[firstStatus]}
                    </div>
                  )}
                </div>

                <div className="order-body">

                  <p>
                    <strong>Table:</strong> {order.tableNumber}
                  </p>
                  <table className="items-table">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Customer</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(order.orders) &&
                        order.orders.map((item, i) => (
                          <tr key={i}>
                            <td>{item.foodName}
                              <small style={{ color: "var(--ui-muted)", display: "block", fontSize: "12px" }}>
                                 {item.addonSummary}
                              </small>
                            </td>
                            <td>{item.qty}</td>
                            <td>
                              {item.customerName}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
        : (<EmptyScreen message="No cancelled orders found for this restaurant." />)}
    </div>
  );
};

export default CancelledOrder;
